import { combineReducers } from 'redux';

import Register from '../../../../store/auth/register/reducer';
import Login from '../../../../store/auth/login/reducer';
import Merchants from '../../../../modules/merchants/store/reducers/reducer';
import Profile from '../../../../store/profile/reducer';
import Util from '../../../../store/utils/reducer';
import Transactions from '../../../../modules/transactions/store/reducers/reducer';
import Customers from '../../../../store/customers/reducer';
import Payments from '../../../../store/payment/reducer';
// import Plans from '../../../../store/plans/reducer';
import Settings from '../../../../store/settings/reducer';
import Invoices from '../../../../store/invoice/reducer';
import Payouts from '../../../../store/payouts/reducer';
import Overview from '../../../../store/overview/reducer';
import Countries from '../../../../modules/countries/store/reducers/reducer';
import BusinessType from '../../../../modules/business_types/store/reducers/reducer';
import User from '../../../../modules/users/store/reducers/reducer';
import BankAccounts from '../../../../modules/bank_account/store/reducers/reducer';
import Banks from '../../../../modules/banks/store/reducers/banks_reducer';
import Subscription from "../../../../modules/recurring/store/subscriptions/reducer/reducer"
import Plans from '../../../../modules/recurring/store/plans/reducer/reducer';
import DirectDebitReducer from '../../../../modules/recurring/store/directDebit/reducer';
import CurrencyReducer from '../../../../modules/currencies/store/reducer/currencyReducer';

const rootReducer = combineReducers({
    Merchants,
    Countries,
    BusinessType,
    User,
    Register,
    // TODO: Remove login reducer ->
    Login,
    Profile,
    Util,
    Transactions,
    Customers,
    Payments,
    // Plans,
    Settings,
    Invoices,
    Payouts,
    Overview,
    Banks,
    BankAccounts,
    Subscription,
    Plans,
    DirectDebitReducer,
    CurrencyReducer
});

export default rootReducer;
